import gql from 'graphql-tag';

export const CreateDispatchIssue = gql`
  mutation CreateDispatchIssueBulk($input: CreateDispatchIssueBulkInput!) {
    createDispatchIssueBulk(input: $input) {
      output {
        error
        output {
          issue {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            rootCause
            rootCauseDescription
            station
            datetime
            dispatcherId
            tripId
            flightIssueDescription
            flightLate
            taxiUsed
            taxiCost
            taxiDetails
            recoveryFlightNumber
            recoveryFlightDatetime
            outboundFlightInfo
            managerId
            crewMemberName
            crewMemberPhone
            crewMemberGiftCardCount
            driverId
            recoveryNeeded
            recoveryCompleted
            driverPhone
            deletedAt
            deletedBy
            traceId
            scheduledTime
            pushTime
            flightType
            vehicleId
            recoveryFlightName
            causedBy {
              id
              createdAt
              createdBy
              updatedAt
              updatedBy
              causedById
              dispatchIssueId
            }
          }
          document {
            document {
              id
              createdAt
              createdBy
              updatedAt
              updatedBy
              issueId
              filename
              fileLocation
              contentType
              fileSize
              md5
              deletedAt
              deletedBy
              traceId
            }
            presignedUrl
          }
        }
      }
    }
  }
`;
